// extracted by mini-css-extract-plugin
export default {"title":"profile_title__tpAO9","password":"profile_password__vKuqN","topRow":"profile_topRow__9ATLq","bottomRow":"profile_bottomRow__3wbJV"};